import { IIndexSignature } from '@selfserve/react-utils';

export const partnerStatusColors: IIndexSignature<string> = {
  0: 'red',
  1: 'green',
  2: 'red',
  3: 'red',
  4: 'yellow',
};

export const subscriptionStatusColors: IIndexSignature<string> = {
  inTrial: 'green',
  active: 'green',
  deleted: 'red',
  pending: 'yellow',
  paused: 'yellow',
};

export const checklistStatusColors: IIndexSignature<string> = {
  enable: 'green',
  disable: 'red',
};
